import React from 'react';

import { StyleSheet, View } from 'react-native';
import { Icon } from 'ucl/components/icon/Icon';

import { Typography } from 'components/ui';
import { t } from 'state/intl/translations';
import { primitive, spacing } from 'styles/constants';

type UnavailableOfferBadgeProps = {
  label?: string;
};

export function UnavailableOfferBadge({ label }: UnavailableOfferBadgeProps) {
  return (
    <View style={styles.badge} testID="unavailable-offer-badge">
      <Icon variant="location" size="3" color={primitive.$bbqBrown} mr="$1" />
      <Typography variant="copyTwo" color={primitive.$bbqBrown} style={styles.label}>
        {label ?? t('notAvailableHere')}
      </Typography>
    </View>
  );
}

const styles = StyleSheet.create({
  badge: {
    flexDirection: 'row',
    alignItems: 'center',
    alignSelf: 'flex-start',
    backgroundColor: primitive.$errorLight,
    borderCurve: 'continuous',
    borderRadius: 4,
    paddingHorizontal: spacing.$2,
    paddingVertical: spacing.$1,
  },
  label: {
    fontSize: 12,
    fontWeight: '600',
  },
});
